// animations/preloadImages.js
import imagesLoaded from 'imagesloaded';

// Image visible au premier écran DE LA PAGE.
// Position mesurée par rapport au container et non à la fenêtre : pendant une transition Barba,
// la nouvelle page est encore placée sous l'ancienne, et son hero serait vu comme « hors écran ».
const isAboveFold = (img, container) => {
  const r = img.getBoundingClientRect();
  const c = container.getBoundingClientRect();
  return r.width > 0 && (r.top - c.top) < window.innerHeight;
};

/**
 * Attend que les images du PREMIER ÉCRAN d'un container soient chargées (dont le hero d'un projet).
 * Les autres (galerie plus bas) se chargent ensuite sans bloquer l'arrivée sur la page.
 * @param {Element} container
 * @param {number}  timeout  - ms max avant de resolve quand même (défaut 15000) : simple sécurité.
 *                             Vers un projet, l'image agrandie de la carte reste affichée
 *                             jusqu'à ce que la photo du hero soit entièrement chargée.
 */
export const preloadImages = (container, timeout = 15000) => {
  return new Promise((resolve) => {
    const imgs = [...container.querySelectorAll('img')]
      .filter((img) => img.loading !== 'lazy' && !img.complete && !img.src.startsWith('data:'))
      .filter((img) => img.classList.contains('article-featured-img') || isAboveFold(img, container));
    if (!imgs.length) { resolve(); return; }

    const timer = setTimeout(resolve, timeout); // fallback sécurité
    imagesLoaded(imgs, () => {
      clearTimeout(timer);
      resolve();
    });
  });
};